__turbopack_context__.v({
  "figcaption": "Nc_hnG_figcaption",
});
